<script setup lang="ts">
import { computed } from 'vue';

import NumberSpinner from '@/shared/components/UI/NumberSpinner.vue';
import { useTranslations } from '@/shared/composables/useTranslations';
import { useProductStore } from '@/shared/pinia/modules/product';
import { useProductQuantitiesStore } from '@/shared/pinia/modules/product-quantities';

withDefaults(
  defineProps<{
    showTitle?: boolean;
  }>(),
  {
    showTitle: true
  }
);

const { t } = useTranslations();

const quantityStore = useProductQuantitiesStore();
const productStore = useProductStore();
const value = computed({
  get() {
    return quantityStore.quantity;
  },
  set(value) {
    quantityStore.updateQuantity(value);
  }
});
</script>

<template>
  <div
    v-if="showTitle"
    class="mb-2 text-base font-bold text-gray-darkest md:text-sm"
  >
    {{ t('product.quantity.entry_qty') }}
  </div>

  <NumberSpinner
    v-model="value"
    :product-name="productStore.productName ?? undefined"
  />
</template>
